export default __webpack_public_path__ + "static/media/product-05.d5fc054c.jpg";